import { createFileRoute, redirect } from "@tanstack/react-router"

export const Route = createFileRoute("/gameplay-facecam-to-shorts")({
  beforeLoad: () => {
    throw redirect({ to: "/tools/gameplay-facecam-to-shorts", statusCode: 301 })
  },
})
